export default __webpack_public_path__ + "static/media/image28.d8194edd.svg";